import { get } from '../../02-tools/index'

export function GlobalNotification() {
    document.addEventListener('click', (evt) => {
        if (evt.target.classList.contains('js-close-global-notification')) {
            evt.preventDefault()
            let notification = evt.target.closest('.js-global-notification')
            notification.classList.add('closed')
        }
    })

    const container = document.querySelector('.js-global-notification')

    const content = container?.querySelector('.js-global-notification-content')
    const url = container?.querySelector('.js-global-notification-url')

    if (!content || !url) {
        return
    }

    get('/api/service-updates/global-notification')
        .then((json) => JSON.parse(json))
        .then((response) => {
            const data = response.data

            if (!data?.content || !data?.url) {
                return
            }

            content.innerHTML = data.content
            url.href = data.url

            container.classList.remove('closed')
        })
}